module.exports = __webpack_public_path__ + "img/7A6959_2D271D_C1B5A9_B4A393-256px.3c417f9a.png";